import React from 'react';

import './styles.scss';

const ContentLink = ({ href, children }) => <a className="blog-content-link" href={href}>{children}</a>

export default ContentLink;
